module.exports = __webpack_public_path__ + "bbb92b610adcd451d648e9756209cc05.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/edit.svg
// module id = 746
// module chunks = 0